import {
  SvgIcon, SelectChangeEvent, Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import { useInput, InputProps, useTranslate } from 'react-admin';

export const IconSelector = (props: InputProps & { iconMap: Record<string, typeof SvgIcon> }) => {

  const { field } = useInput(props);
  const translate = useTranslate();

  const handleChange = (event: SelectChangeEvent<string>) => {

    field.onChange(event.target.value);

  };

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label">
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <Select
        displayEmpty
        value={field.value == null || field.value === '' ? '' : String(field.value)}
        onChange={handleChange}
        renderValue={(selected) => {

          if (selected === '') {

            return (
              <>
                {translate('resources.security-inventory-categories.text.select_icon')}
              </>
            );

          }
          const Icon = props.iconMap[selected];
          if (!Icon) {

            return translate('resources.security-inventory-categories.text.select_icon');

          }
          return <Icon fontSize="small" />;

        }}
        sx={{
          mb: 5,
          backgroundColor: '#f1f1f1 !important',
          boxSizing: 'border-box',
          minHeight: 40,
          height: 40,
          alignItems: 'center',
          borderRadius: '5px',
          '& fieldset': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box',
          },
        }}
        MenuProps={{
          MenuListProps: {
            sx: {
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1px',
              maxHeight: '280px',
            },
          },
        }}
      >
        {Object.entries(props.iconMap).map(([key, Icon]) => (
          <MenuItem key={key} value={key} aria-label={key}>
            <Icon titleAccess={key}/>
          </MenuItem>
        ))}
      </Select>
    </>
  );

};
